/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpenseGroup } from './ExpenseGroup';
import type { ProductParams } from './ProductParams';
export type CalculatorConfigInput = {
    product_type: CalculatorConfigInput.product_type;
    tax_system: string;
    residency: string;
    rf_payment_share: number;
    rf_commission: number;
    foreign_commission: number;
    installment_sale_percent: number;
    installment_commission_percent: number;
    expense_groups: Record<string, Array<ExpenseGroup>>;
    product_params: Record<string, ProductParams>;
    product_expenses: Record<string, Record<string, any>>;
};
export namespace CalculatorConfigInput {
    export enum product_type {
        COURSE = 'course',
        SUBSCRIPTION = 'subscription',
        SERVICE = 'service',
    }
}

